// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type CreateInvoiceDataMutationVariables = Types.Exact<{
  upsertInvoiceDataDTO: Types.UpsertInvoiceDataDtoInput;
}>;


export type CreateInvoiceDataMutationResult = { __typename?: 'Mutation', createInvoiceData: number | null };

export const CreateInvoiceDataGql = gql`
    mutation CreateInvoiceData($upsertInvoiceDataDTO: UpsertInvoiceDataDTOInput!) {
  createInvoiceData(upsertInvoiceDataDTO: $upsertInvoiceDataDTO)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateInvoiceDataInjectable extends Apollo.Mutation<CreateInvoiceDataMutationResult, CreateInvoiceDataMutationVariables> {
    override document = CreateInvoiceDataGql;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
/* eslint-enable */